export default __webpack_public_path__ + "3631bca2f9d67d95083714f3a7caa7b4.png";